import './nomascantina/style';
import FormStructure from './nomascantina/form_structure';

export default FormStructure;